import { render, staticRenderFns } from "./recordScreen.vue?vue&type=template&id=83cf925a&scoped=true"
import script from "./recordScreen.vue?vue&type=script&lang=js"
export * from "./recordScreen.vue?vue&type=script&lang=js"
import style0 from "./recordScreen.vue?vue&type=style&index=0&id=83cf925a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cf925a",
  null
  
)

export default component.exports